import { getRandomString } from "../helpers/CommonFunctions";
import { defaultPaymentSheetHeightPx, minimumPaymentSheetMarginPx, paymentSheetDcfActiveClassName, paymentSheetOverlayClassName, } from "./PaymentSheetStyles";
import { srciUiComponentId } from "./ui/SrciUi";
/** @internal */
var SrciDcfFrame = /** @class */ (function () {
    function SrciDcfFrame() {
        var _this = this;
        // Keep a stable, bound callback reference for addEventListener/removeEventListener.
        this.onResizeEvent = function () {
            _this.onResize(srciUiComponentId);
        };
        this.dcfIframeId = "dcfIframeId-".concat(getRandomString());
    }
    SrciDcfFrame.prototype.createDcfIframe = function (paymentSheetContainer, isDcfFlowPopUp) {
        if (isDcfFlowPopUp === false) {
            var dcfIframe = document.createElement("iframe");
            dcfIframe.id = this.dcfIframeId;
            dcfIframe.name = this.dcfIframeId;
            dcfIframe.style.cssText = "position: absolute; border: none; z-index: -1;";
            dcfIframe.width = "0px";
            dcfIframe.height = "0px";
            paymentSheetContainer.append(dcfIframe);
        }
    };
    SrciDcfFrame.prototype.getDcfWindowRef = function (srciUiComponentId) {
        var _this = this;
        var dcfIframe = document.getElementById(this.dcfIframeId);
        dcfIframe.style.cssText =
            "position: absolute; border: none; border-radius: 20px; z-index: -1; visibility: hidden; background: transparent;";
        dcfIframe.onload = function () {
            //Setting back background: white, because VISA DCF screen has .95 opacity and card list is visible underneath.
            dcfIframe.style.background = "white";
            dcfIframe.style.visibility = "visible";
            dcfIframe.style.zIndex = "99999";
            _this.activateDcfPresentation(dcfIframe.parentElement);
        };
        this.updateDcfIframeBounds(dcfIframe, srciUiComponentId);
        return window.open(undefined, this.dcfIframeId);
    };
    SrciDcfFrame.prototype.activateDcfPresentation = function (paymentSheetContainer) {
        this.deactivateDcfPresentation();
        if (!paymentSheetContainer)
            return;
        this.activePaymentSheetContainer = paymentSheetContainer;
        paymentSheetContainer.classList.add(paymentSheetDcfActiveClassName);
    };
    SrciDcfFrame.prototype.deactivateDcfPresentation = function () {
        var _a;
        (_a = this.activePaymentSheetContainer) === null || _a === void 0 ? void 0 : _a.classList.remove(paymentSheetDcfActiveClassName);
        this.activePaymentSheetContainer = undefined;
    };
    SrciDcfFrame.prototype.updateDcfIframeBounds = function (dcfIframe, srciUiComponentId) {
        var srciUiComponent = document.getElementById(srciUiComponentId);
        if (!srciUiComponent)
            return null;
        var paymentSheetContainer = srciUiComponent.parentElement;
        var availableOverlayHeight = paymentSheetContainer
            ? paymentSheetContainer.clientHeight - minimumPaymentSheetMarginPx * 2
            : 0;
        var dcfHeight = (paymentSheetContainer === null || paymentSheetContainer === void 0 ? void 0 : paymentSheetContainer.classList.contains(paymentSheetOverlayClassName)) && availableOverlayHeight > 0
            ? Math.min(defaultPaymentSheetHeightPx, availableOverlayHeight)
            : srciUiComponent.clientHeight;
        dcfIframe.style.left = "".concat(srciUiComponent.offsetLeft, "px");
        dcfIframe.style.top = "".concat(srciUiComponent.offsetTop, "px");
        dcfIframe.width = "".concat(srciUiComponent.clientWidth, "px");
        dcfIframe.height = "".concat(dcfHeight, "px");
    };
    SrciDcfFrame.prototype.onResize = function (srciUiComponentId) {
        var dcfIframe = document.getElementById(this.dcfIframeId);
        this.updateDcfIframeBounds(dcfIframe, srciUiComponentId);
    };
    SrciDcfFrame.prototype.hideDcfIframe = function (isDcfFlowPopUp) {
        this.deactivateDcfPresentation();
        if (isDcfFlowPopUp === false) {
            var dcfIframe = document.getElementById(this.dcfIframeId);
            var parentElement = dcfIframe && dcfIframe.parentElement;
            dcfIframe && dcfIframe.remove();
            parentElement && this.createDcfIframe(parentElement, isDcfFlowPopUp);
        }
    };
    return SrciDcfFrame;
}());
export { SrciDcfFrame };
